import { gsap } from 'gsap';

const SELECTOR = '[data-organization-text]';
const PART_SELECTOR = '.organization-text__part';
const ACTIVE_CLASS = 'organization-text__part--active';

const animateOrganizationText = (section) => {
  const parts = Array.from(section.querySelectorAll(PART_SELECTOR));
  const inactiveParts = parts.filter((part) => !part.classList.contains(ACTIVE_CLASS));

  if (!inactiveParts.length) {
    return;
  }

  gsap.timeline().to(inactiveParts, {
    color: '#060628',
    duration: 0.8,
    stagger: 0.6,
    ease: 'power2.out',
    onComplete: () => {
      inactiveParts.forEach((part) => part.classList.add(ACTIVE_CLASS));
      section.dataset.organizationTextAnimated = 'true';
      section.dataset.organizationTextAnimating = 'false';
    },
  });
};

const initOrganizationText = () => {
  const sections = document.querySelectorAll(SELECTOR);

  if (!sections.length) {
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const section = entry.target;

        if (!entry.isIntersecting) {
          return;
        }

        if (section.dataset.organizationTextAnimated === 'true') {
          return;
        }

        if (section.dataset.organizationTextAnimating === 'true') {
          return;
        }

        section.dataset.organizationTextAnimating = 'true';
        animateOrganizationText(section);
      });
    },
    {
      threshold: 0.2,
      rootMargin: '0px 0px -10% 0px',
    }
  );

  sections.forEach((section) => {
    observer.observe(section);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initOrganizationText);
} else {
  initOrganizationText();
}
